export default __webpack_public_path__ + "static/media/marauders-map-v5.1-01-01.470fa117.jpg";